import React, { useRef, useEffect, useState } from 'react'
import ProgressBar from "@ramonak/react-progress-bar";
import { css } from 'glamor'

export type FakeProgressBarTypeProps = {
    initialValue: number,
    maxComplete?: number,
    customInterval?: number,
    customStep?: number
}

export const FakeProgressBar = ({ initialValue, customStep, maxComplete, customInterval  }: FakeProgressBarTypeProps) => {
    const step = useRef(customStep ?? 0.3)
    const current_progress = useRef(initialValue / 30)
    const [, forceRerender] = useState(Date.now())
    const progressBarValue = useRef(initialValue)

    useEffect(() => {
        const interval = setInterval(function () {
            current_progress.current += step.current
            const progress = Math.round(Math.atan(current_progress.current) / (Math.PI / 2) * (maxComplete ?? 95) * 1000) / 1000
            progressBarValue.current = progress
            if (current_progress.current >= 100) {
                clearInterval(interval);
            } else if (current_progress.current >= (initialValue >= 50 ? 60 : ((maxComplete ?? 95) <= 50 ? 30 : 70))) {
                step.current = 0.1
            }
            forceRerender(Date.now())
        }, (customInterval ?? 2000 ))
    }, [])


    return (
        <div
            {
            ...css({
                width: '100%',
            })
            }
        >
            <ProgressBar
                completed={parseFloat(progressBarValue.current.toString())}
                bgColor="#0072BC"
                height={"10px"}
                baseBgColor="#303641"
                isLabelVisible={false}
            />
        </div>
    )
}